/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult } from './RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult';
import {
    RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultFromJSON,
    RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultFromJSONTyped,
    RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultToJSON,
    RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultToJSONTyped,
} from './RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1GetEntryCountResult
 */
export interface ApiResponse1GetEntryCountResult {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1GetEntryCountResult
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1GetEntryCountResult
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult}
     * @memberof ApiResponse1GetEntryCountResult
     */
    data?: RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResult;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1GetEntryCountResult
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1GetEntryCountResult interface.
 */
export function instanceOfApiResponse1GetEntryCountResult(value: object): value is ApiResponse1GetEntryCountResult {
    return true;
}

export function ApiResponse1GetEntryCountResultFromJSON(json: any): ApiResponse1GetEntryCountResult {
    return ApiResponse1GetEntryCountResultFromJSONTyped(json, false);
}

export function ApiResponse1GetEntryCountResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1GetEntryCountResult {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1GetEntryCountResultToJSON(json: any): ApiResponse1GetEntryCountResult {
    return ApiResponse1GetEntryCountResultToJSONTyped(json, false);
}

export function ApiResponse1GetEntryCountResultToJSONTyped(value?: ApiResponse1GetEntryCountResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomApplicationFeaturesEntriesQueriesCountGetEntryCountResultToJSON(value['data']),
        'errors': value['errors'],
    };
}

